import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import RenderTiptap from '../components/Editor/RenderTiptap';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';

function parseConteudo(c) {
  if (!c) return null;
  if (typeof c === 'object') return c;
  try { return JSON.parse(c); } catch (_) { return null; }
}

/**
 * Página de Cultura — mostra o documento tipo 'cultura' (o primeiro ativo).
 * Antes era texto chumbado no código; agora o RH edita pelo editor de documentos.
 */
export default function Cultura() {
  const { temPermissao } = useAuth();
  const podeEditar = temPermissao('editar_documento');
  const [doc, setDoc] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    api.get('/documentos', { params: { tipo: 'cultura' } })
      .then(({ data }) => {
        const primeiro = (data.documentos || [])[0];
        if (!primeiro) return null;
        return api.get(`/documentos/${primeiro.id}`).then(r => setDoc(r.data.documento));
      })
      .catch(() => setErro('Não foi possível carregar a página de cultura.'))
      .finally(() => setCarregando(false));
  }, []);

  const conteudo = parseConteudo(doc?.conteudo);

  return (
    <>
      <Header />
      <main className="conteudo-container">
        <div className="conteudo-card">
          {carregando && <div>Carregando…</div>}
          {erro && <div className="erro">{erro}</div>}

          {!carregando && !erro && !doc && (
            <>
              <h1>Código de Cultura</h1>
              <p>O conteúdo de cultura ainda não foi publicado.</p>
              {podeEditar && (
                <Link to="/admin/documentos/novo" className="btn-centrao">
                  <i className="bi bi-plus-lg me-1"></i> Criar (tipo "Cultura")
                </Link>
              )}
            </>
          )}

          {doc && (
            <>
              <div className="doc-artigo-cab">
                <h1>{doc.titulo}</h1>
                {podeEditar && (
                  <div className="doc-artigo-acoes">
                    <Link to={`/admin/documentos/${doc.id}/editar`} className="btn-centrao-laranja" title="Editar">
                      <i className="bi bi-pencil"></i>
                    </Link>
                  </div>
                )}
              </div>
              {conteudo && <RenderTiptap conteudo={conteudo} />}
            </>
          )}
        </div>
      </main>
    </>
  );
}
